const normalizeJobOfferPath = (value, baseOrigin) => {
	if (typeof value !== 'string' || !value) {
		return null
	}

	if (value.startsWith('/') && !value.startsWith('//')) {
		return value
	}

	try {
		const resolvedUrl = new URL(value, baseOrigin)

		return `${resolvedUrl.pathname}${resolvedUrl.search}${resolvedUrl.hash}`
	} catch (error) {
		return null
	}
}

export const getJobOfferRedirectPath = (
	jobOffer,
	currentPath = '/',
	baseOrigin = 'https://app.apropos.jobs'
) => {
	const frontendRoute = normalizeJobOfferPath(
		jobOffer?.frontend_route,
		baseOrigin
	)
	if (frontendRoute) {
		return frontendRoute
	}

	const frontendUrl = normalizeJobOfferPath(
		jobOffer?.frontend_url,
		baseOrigin
	)
	if (frontendUrl) {
		return frontendUrl
	}

	return currentPath || '/'
}
